// extracted by mini-css-extract-plugin
module.exports = {"container":"_1cZzCitsFwy7RncePpLo-H","groupsList":"_2RdD4LwwvDBhRiQmJutcv"};